import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonActionType } from '../state-management/model/enums/state.enums';
import { WebsiteStateService } from '../state-management/services/website-state.service';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  public onClick(elemId: string): void {
    const currentElement = this.stateService.getCurrentElement(elemId)();
    
    if (currentElement.success === false) return;
    const config = currentElement.payload.buttonConfig;
    if (!config) return;
    const { type, params } = config;
    if (!params) return;

    switch (type) {
      case ButtonActionType.ScrollTo:
        this.scrollToElement(params['target']);
        break;
      case ButtonActionType.Navigate:
        this.navigateTo(params['url']);
        break;
      case ButtonActionType.NavigateAndScrollTo:
        this.navigateAndScrollTo(params['url'], params['target'], false);
        break;
      case ButtonActionType.ExternalLink:
        window.open(params['url'], '_blank');
        break;
      default:
        break;
    }
  }

  public scrollToElement(target: string): void {
    const element = document.getElementById(target);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
    }
  }

  public navigateTo(url: string): void {
    this.router.navigate([url]);
  }

  public navigateAndScrollTo(targetURL: string, targetElementId: string, stayOnURL: boolean = false): void {
    if (stayOnURL) {
      this.scrollToElement(targetElementId);
      return;
    }

    const currentUrl = this.router.url;
    if (currentUrl === targetURL) {
      this.scrollToElement(targetElementId);
    } else {
      this.router.navigate([targetURL]).then(() => {
        setTimeout(() => {
          this.scrollToElement(targetElementId);
        }, 100);
      });
    }
  }

  constructor(
    private stateService: WebsiteStateService,
    private router: Router, 
  ) {}

}
